import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';
import { cn } from '../lib/utils';

const ThemeToggle = ({ className }) => {
    const { theme, toggleTheme, isDark } = useTheme();

    return (
        <button
            onClick={toggleTheme}
            className={cn(
                "relative flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-200",
                "hover:bg-accent focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-0",
                className
            )}
            aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
            data-testid="theme-toggle"
        >
            <Sun 
                className={cn(
                    "absolute h-5 w-5 transition-all duration-300",
                    isDark 
                        ? "opacity-0 rotate-90 scale-0" 
                        : "opacity-100 rotate-0 scale-100 text-amber-500"
                )} 
            />
            <Moon 
                className={cn(
                    "absolute h-5 w-5 transition-all duration-300",
                    isDark 
                        ? "opacity-100 rotate-0 scale-100 text-blue-400" 
                        : "opacity-0 -rotate-90 scale-0"
                )} 
            />
        </button>
    );
};

export default ThemeToggle;
